module.exports = __webpack_public_path__ + "img/actions_yellow.455f22f1.svg";